<template>
	<div class="position-relative">
	    <transition name="vue-table-loader">
	        <div class="vue-table-loader"v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Channel"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
		    <vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				:append-params="moreParams"
				noDataTemplate="No Channels Found"
				pagination-path=""
				@vuetable:loaded="onLoaded"
				@vuetable:pagination-data="onPaginationData"
		    >
	    	    <template slot="actions" slot-scope="props">
		    	        <a v-if="userCanEdit" class="btn btn-outline-primary" :href="'/channels/' + props.rowData.id + '/edit/'">View</a>
		    	        <div v-else class="no-edit"></div>
		    	</template>
		    	<template slot="logo" slot-scope="props">
                    <img v-if="!props.rowData.logo"  class="channel-logo" :src="baseUrl + '/images/channels/logo-'+props.rowData.type[Object.keys(props.rowData.type)]+'.png'" alt="">
                    <img v-else  class="channel-logo" :src="props.rowData.logo" alt="">
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.no-edit{
		min-height: 38px;
	}
	.channel-logo{
		width: 35px;
	}
</style>

<style lang="scss">
	.currency-no-image{
		font-size: 38px;
		color: #eee;
	}
	.currency-logo{
		max-height: 40px;
		max-width: 100px;
	}
	.channel-logo-col{
		width:70px;
	}
</style>

<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';

	Vue.use(VueEvents)

	export default {
	    name: 'channels-listing',
	    props: [
	        "canEdit"
        ],
	    components:{
	     	'base-filter-bar': BaseFilterBar,
	     	'base-pagination': BasePagination,
	     	'base-pagination-info': BasePaginationInfo,
	     	'base-select-visible': BaseSelectVisible,
	    },
	    data() {
	    	return {
	    		perPage: 10,
	    		moreParams: {},
	    		selected: null,
	    		loading: true,
                userCanEdit: this.canEdit,
				fields: [
					{
						name: '__slot:logo',
						title: 'Type',
						titleClass: 'channel-logo-col',
					},
					{
						name: 'channel_name',
						title: 'Name',
						sortField: 'channel_name',
					},
                    {
                        name: 'price_base',
                        title: 'Price base',
                        sortField: 'price_base',
                        titleClass: 'actions-single-column',
                    },
					{
						name: 'sync',
						title: 'Enabled',
						sortField: 'sync',
						callback: 'channelSyncing',
						titleClass: 'actions-single-column',
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				grid: base_url + "/channels/grid",
				baseUrl: base_url,
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				}
			}
	    },
	    mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
	    methods: {
	        displayLogo (value) {
	          	if (value == null){
                    return '<div class="currency-no-image text-center"><i class="fa fa-picture-o" aria-hidden="true"></i></div>';
                }
                return '<img class="currency-logo" src="' + value + '">';
	        },
	        channelSyncing (value) {
	         	return value == 1
	           		? '<div class="badge badge-success w-100">Yes</div>'
	           		: '<div class="badge badge-warning w-100">No</div>'
	        },
	        onPaginationData (paginationData) {
	          	this.$refs.pagination.setPaginationData(paginationData)
	          	this.$refs.paginationInfo.setPaginationData(paginationData)
	        },
	        onChangePage (page) {
	          	this.$refs.vuetable.changePage(page)
	        },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            }
		}
	};
</script>
